import PendoButtonGroup from '../../button-group/pendo-button-group.vue.js';
import PendoButton from '../../button/pendo-button.vue.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import { setStyles } from '../../../utils/dom.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoSplitButtonTrigger',
  components: {
    PendoButton,
    PendoButtonGroup,
    PendoIcon
  },
  inject: ['multiselect'],
  inheritAttrs: false,
  props: {
    type: {
      type: String
    },
    theme: {
      type: String
    },
    size: {
      type: String
    },
    label: {
      type: String
    },
    prefixIcon: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'multiselect.isOpen': function (isOpen) {
      if (isOpen && this.$refs.trigger && this.$refs.trigger.$el) {
        this.$refs.trigger.$el.focus();
      }
    }
  },
  mounted: _async(function () {
    const _this = this;
    return _await(_this.$nextTick(), function () {
      if (_this.$refs.trigger && _this.$refs.trigger.$el) {
        setStyles(_this.$refs.trigger.$el, {
          minWidth: '0px',
          width: '26px'
        });
      }
    });
  }),
  methods: {
    onButtonClick(event) {
      if (this.multiselect.isOpen) {
        this.multiselect.toggleMenu();
      }
      this.$emit('click', event);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-split-button-trigger.vue2.js.map
